/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListUserSessionIssuerCimdClientsResult,
  ListUserSessionIssuerCimdClientsResult$inboundSchema,
} from "../components/listusersessionissuercimdclientsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListUserSessionIssuerCimdClientsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListUserSessionIssuerCimdClientsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListUserSessionIssuerCimdClientsSecurity = {
  option1?: ListUserSessionIssuerCimdClientsSecurityOption1 | undefined;
  option2?: ListUserSessionIssuerCimdClientsSecurityOption2 | undefined;
};

export type ListUserSessionIssuerCimdClientsRequest = {
  /**
   * The user_session_issuer whose custom CIMD clients are listed.
   */
  userSessionIssuerId: string;
  /**
   * Pagination cursor: id of the last item from the previous page.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListUserSessionIssuerCimdClientsResponse = {
  result: ListUserSessionIssuerCimdClientsResult;
};

/** @internal */
export type ListUserSessionIssuerCimdClientsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListUserSessionIssuerCimdClientsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListUserSessionIssuerCimdClientsSecurityOption1$Outbound,
    ListUserSessionIssuerCimdClientsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listUserSessionIssuerCimdClientsSecurityOption1ToJSON(
  listUserSessionIssuerCimdClientsSecurityOption1:
    ListUserSessionIssuerCimdClientsSecurityOption1,
): string {
  return JSON.stringify(
    ListUserSessionIssuerCimdClientsSecurityOption1$outboundSchema.parse(
      listUserSessionIssuerCimdClientsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListUserSessionIssuerCimdClientsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListUserSessionIssuerCimdClientsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListUserSessionIssuerCimdClientsSecurityOption2$Outbound,
    ListUserSessionIssuerCimdClientsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listUserSessionIssuerCimdClientsSecurityOption2ToJSON(
  listUserSessionIssuerCimdClientsSecurityOption2:
    ListUserSessionIssuerCimdClientsSecurityOption2,
): string {
  return JSON.stringify(
    ListUserSessionIssuerCimdClientsSecurityOption2$outboundSchema.parse(
      listUserSessionIssuerCimdClientsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListUserSessionIssuerCimdClientsSecurity$Outbound = {
  Option1?:
    | ListUserSessionIssuerCimdClientsSecurityOption1$Outbound
    | undefined;
  Option2?:
    | ListUserSessionIssuerCimdClientsSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const ListUserSessionIssuerCimdClientsSecurity$outboundSchema:
  z.ZodMiniType<
    ListUserSessionIssuerCimdClientsSecurity$Outbound,
    ListUserSessionIssuerCimdClientsSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        ListUserSessionIssuerCimdClientsSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        ListUserSessionIssuerCimdClientsSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function listUserSessionIssuerCimdClientsSecurityToJSON(
  listUserSessionIssuerCimdClientsSecurity:
    ListUserSessionIssuerCimdClientsSecurity,
): string {
  return JSON.stringify(
    ListUserSessionIssuerCimdClientsSecurity$outboundSchema.parse(
      listUserSessionIssuerCimdClientsSecurity,
    ),
  );
}

/** @internal */
export type ListUserSessionIssuerCimdClientsRequest$Outbound = {
  user_session_issuer_id: string;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListUserSessionIssuerCimdClientsRequest$outboundSchema:
  z.ZodMiniType<
    ListUserSessionIssuerCimdClientsRequest$Outbound,
    ListUserSessionIssuerCimdClientsRequest
  > = z.pipe(
    z.object({
      userSessionIssuerId: z.string(),
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        userSessionIssuerId: "user_session_issuer_id",
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function listUserSessionIssuerCimdClientsRequestToJSON(
  listUserSessionIssuerCimdClientsRequest:
    ListUserSessionIssuerCimdClientsRequest,
): string {
  return JSON.stringify(
    ListUserSessionIssuerCimdClientsRequest$outboundSchema.parse(
      listUserSessionIssuerCimdClientsRequest,
    ),
  );
}

/** @internal */
export const ListUserSessionIssuerCimdClientsResponse$inboundSchema:
  z.ZodMiniType<ListUserSessionIssuerCimdClientsResponse, unknown> = z.pipe(
    z.object({
      Result: ListUserSessionIssuerCimdClientsResult$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "Result": "result",
      });
    }),
  );

export function listUserSessionIssuerCimdClientsResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  ListUserSessionIssuerCimdClientsResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListUserSessionIssuerCimdClientsResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListUserSessionIssuerCimdClientsResponse' from JSON`,
  );
}
